<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading"><i class="fa fa-cogs"></i>
			Manage {{this.lblHeading}}
		</h1>
	</div>
	<div class="row">
		<div *ngIf="isRemove" class="text-danger col-md-12">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
		</div>
		<div class="col-md-12" *ngIf="!isRemove">
			<div class="table-responsive">
				<table id="vTypes" border="1" class="table tbl-stl custom_table">
					<thead class="thead-inverse hgt-btn">
						<tr style="vertical-align:middle;" class="hgt-btn">
							<th class="bfr-end-col">
								Code
								<i class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Description
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
									(click)="utility.onSort(2)"></i>
							</th>
							<th class="bfr-end-col">
								Download?
							</th>
							<th class="bfr-end-col">
								Template?
							</th>
							<th class="bfr-end-col">
								Active?
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
									(click)="utility.onSort(3)"></i>
							</th>
							<th class="bfr-end-col">
								Sort Order
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
									(click)="utility.onSort(5)"></i>
							</th>
							<th class="bfr-end-col">
								Group
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
									(click)="utility.onSort(4)"></i>
							</th>
							<th class="bfr-end-col">Display</th>
							<th class="btn-show hgt-btn bfr-end-col text-center">
								<a [routerLink]="['/document/type/add']" title="">
									<span title="Add a New Document Type" class=" btn-add btn btn-primary btn-sm"><i
											class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
								</a>
							</th>
						</tr>
					</thead>
					<tr 
						*ngFor="let vDocType of vDocTypes  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
						<td class="bfr-end-col" style="white-space: nowrap;">{{vDocType.code}}</td>
						<td class="bfr-end-col" style="width: 40%;">{{vDocType.description}}</td>
						<td class="bfr-end-col">{{utility.isActive(vDocType.is_download)}}</td>
						<td class="bfr-end-col">{{utility.isActive(vDocType.is_template)}}</td>
						<td class="bfr-end-col">{{utility.isActive(vDocType.is_active)}}</td>
						<td class="bfr-end-col">{{vDocType.sort_order}}</td>
						<td class="bfr-end-col">{{vDocType.group_code}}</td>
						<td class="bfr-end-col">{{utility.showDisplayIndicator(vDocType.display_ind)}}</td>
						<td class="btn-show bfr-end-col text-center">
							<div class="actions_wrap">
								<a [routerLink]="['/document/type/edit',vDocType.id]"><span title="Edit Document Type"
										class="btn btn-success btn-sm"><i
											class="fa fa-pencil fa-fw"></i></span></a>
								<span title="Delete Document Type" class="btn btn-danger btn-sm" style="margin-left: 8px;"
									(click)="onConfirm(vDocType)"><i class="fa fa-trash-o fa-fw"></i></span>
							</div>
						</td>
					</tr>
					<tfoot>
						<tr *ngIf="vDocTypes.length > 1" class="pagination_row">
							<td colspan="9" class="rm-brd">
								<div class="row">
									<div class="col-4">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h" for="show-id"
													>Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-8 text-right">
										<pagination-controls (pageChange)="utility.page = $event"
											style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="4" class="rm-brd">
								<span class="text-info text-small">No Document Types found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>